<template>
  <Gallery category="digital" />
</template>

<script>
import Gallery from '@/components/Gallery'

export default {
  components: {
    Gallery,
  },
}
</script>

